module.exports = __webpack_public_path__ + "static/placeholder-e9cf9847cc93a205ee4e8a6e60dffeff.png";